import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Tooltip,
  Button,
  Typography,
  Box,
  Paper,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Select,
} from "@material-ui/core";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import useStyles from "../../../../themes/style.js";
import { IoChevronDownSharp } from "react-icons/io5";
import axios from "axios";
import { useNotification } from "../../../../hooks/useNotification.js";
import excel_icon from "../../../../images/svg/excel-icon.svg";
import * as XLSX from "xlsx";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import "../../../../css/view-resume.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { BsFillInfoCircleFill } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { AiTwotoneEdit } from "react-icons/ai";

const allFields = [
  {
    name: "basicAllowanceArrears",
    label: "Basic Allowance Arrears",
    placeholder: "Enter amount",
  },
  { name: "hraArrears", label: "HRA Arrears", placeholder: "Enter amount" },
  {
    name: "telephoneAllowanceArrear",
    label: "Telephone Allowance Arrears",
    placeholder: "Enter amount",
  },
  {
    name: "conveyanceArrears",
    label: "Conveyance Arrears",
    placeholder: "Enter amount",
  },
  {
    name: "medicalAllowanceArrear",
    label: "Medical Allowance Arrears",
    placeholder: "Enter amount",
  },
  {
    name: "otherAllowanceArrear",
    label: "Other Allowance Arrears",
    placeholder: "Enter amount",
  },
  { name: "bonus", label: "Bonus", placeholder: "Enter amount" },
  { name: "incentives", label: "Incentives", placeholder: "Enter amount" },
  {
    name: "otherEarnings",
    label: "Other Earnings",
    placeholder: "Enter amount",
  },
  {
    name: "shiftAllowanceArrears",
    label: "Shift Allowance Arrears",
    placeholder: "Enter amount",
  },
  {
    name: "consultantArrears",
    label: "Consultant Arrears",
    placeholder: "Enter amount",
  },
  { name: "arrears", label: "Arrears", placeholder: "Enter amount" },
  {
    name: "statutoryBonusArrears",
    label: "Statutory Bonus Arrears",
    placeholder: "Enter amount",
  },
  {
    name: "rolePerformanceBonus",
    label: "Role Performance Bonus",
    placeholder: "Enter amount",
  },
  {
    name: "monthlyPerformanceArrears",
    label: "Monthly Performance Arrears",
    placeholder: "Enter amount",
  },
  {
    name: "refundForLastMonthDeduction",
    label: "Refund for Last Month Deduction",
    placeholder: "Enter amount",
  },
  { name: "incomeTax", label: "Income Tax", placeholder: "Enter amount" },
  {
    name: "otherDeduction",
    label: "Other Deduction",
    placeholder: "Enter amount",
  },
  {
    name: "noticePeriodDeduction",
    label: "Notice Period Deduction",
    placeholder: "Enter amount",
  },
  {
    name: "specialPurposeDeduction",
    label: "Special Purpose Deduction",
    placeholder: "Enter amount",
  },
  {
    name: "standardDeduction",
    label: "Standard Deduction",
    placeholder: "Enter amount",
  },
  { name: "totalGross", label: "Total Gross", placeholder: "Enter amount" },
  {
    name: "totalDeduction",
    label: "Total Deduction",
    placeholder: "Enter amount",
  },
  { name: "netValue", label: "Net Value", placeholder: "Enter amount" },
];

const UploadQuickPayslip = () => {
  const classes = useStyles();
  const calendarRef = useRef(null);

  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");
  const [empPayslipData, setEmpPayslipData] = useState([]);
  const [allUserName, setAllUserName] = useState([]);

  const [payslipGenerateDate, setPayslipGenerateDate] = useState(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [payslipUploadModal, setPayslipUploadModal] = useState(false);
  const [editPayslipFields, setEditPayslipFields] = useState({});

  const manualFields = {
    joinDate: Yup.string().required("Join Date is required"),
    modeOfPayment: Yup.string().required("Mode of Payment is required"),
    effectiveWorkdays: Yup.number()
      .positive()
      .integer()
      .transform((_, val) => (val !== "" ? Number(val) : null))
      .typeError("value must be a number")
      .required("Effective Workdays is required"),
    lopCount: Yup.number()
      .min(0, "Cannot be negative")
      .transform((_, val) => (val !== "" ? Number(val) : null))
      .typeError("value must be a number")
      .required("Loss of Pay is required"),
  };

  const validationSchema = Yup.object({
    ...manualFields,
    ...allFields.reduce((schema, field) => {
      schema[field.name] = Yup.number()
        .min(0, `${field.label} cannot be negative`)
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number")
        .required("Loss of Pay is required")
        .default(0);
      return schema;
    }, {}),
  });

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handlePayslipMonthChange = (date) => {
    setCalendarOpen(!calendarOpen);
    setPayslipGenerateDate(date);
  };
  const handlePayslipCalendarOpen = (e) => {
    e.preventDefault();
    setCalendarOpen(!calendarOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setCalendarOpen(false);
      }
    }

    if (calendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarOpen]);

  const transformPayslipData = (data) => {
    return data.map((item) => {
      const emailData = allUserName.find((user) => user.email === item.Email);
      console.log(emailData);
      return {
        id: emailData?.id || null,
        name: item.Name,
        email: item.Email,
        joinDate: item["Join Date"],
        modeOfPayment: item["Mode of Payment"],
        daysInMonth: item["Days in Month"],
        effectiveWorkdays: item["Effective Workdays"],
        lopCount: item["Loss of Pay"],

        // Earnings
        basicAllowanceArrears: item["Basic Allowance Arrears"],
        hraArrears: item["HRA Arrears"],
        telephoneAllowanceArrear: item["Telephone Allowance Arrears"],
        conveyanceArrears: item["Conveyance Arrears"],
        medicalAllowanceArrear: item["Medical Allowance Arrears"],
        otherAllowanceArrear: item["Other Allowance Arrears"],
        bonus: item["Bonus"],
        incentives: item["Incentives"],
        otherEarnings: item["Other Earnings"],
        shiftAllowanceArrears: item["Shift Allowance Arrears"],
        consultantArrears: item["Consultant Arrears"],
        arrears: item["Arrears"],
        statutoryBonusArrears: item["Statutory Bonus Arrears"],
        rolePerformanceBonus: item["Role Performance Bonus"],
        monthlyPerformanceArrears: item["Monthly Performance Arrears"],
        refundForLastMonthDeduction: item["Refund For Last Month Deduction"],

        // Deductions
        incomeTax: item["Income Tax"],
        otherDeduction: item["Other Deduction"],
        noticePeriodDeduction: item["Notice Period Deduction"],
        specialPurposeDeduction: item["Special Purpose Deduction"],
        standardDeduction: item["Standard Deduction"],

        // Totals
        totalGross: item["Total Gross"],
        totalDeduction: item["Total Deduction"],
        netValue: item["Net Value"],
      };
    });
  };

  const uploadAndConvertXlsx = async (event) => {
    try {
      const target = event.target;
      const file = target.files[0];
      setLoader(true);

      if (!file.name.endsWith(".xlsx")) {
        setLoader(false);
        handleNotificationCall(
          "error",
          "Invalid file format. Please select an XLSX file",
        );
        return;
      }

      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const records = XLSX.utils.sheet_to_json(sheet);
          console.log("Data Records:", records);
          const newRecords = transformPayslipData(records);
          setEmpPayslipData(newRecords);
        };

        reader.readAsBinaryString(file);
        console.log("Records:", reader.readAsBinaryString(file));
      } else {
        handleNotificationCall("error", "Only choose xlsx format");
        setLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoader(false);
    }
  };

  const handleUpload = async (file) => {
    if (!selectedFile) {
      setUploadStatus("Please select a file to upload.");
      return;
    }

    var fileName = file.name.split(".").pop();

    if (fileName !== "pdf") {
      handleNotificationCall("error", "Invalid File Format");
      return;
    }

    const formData = new FormData();
    formData.append("document", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/uploadPolicyHandBook`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
      }
    } catch (error) {
      setUploadStatus(
        `Upload failed: ${error.response?.data?.message || error.message}`,
      );
    }
  };

  useEffect(() => {
    getAllUserList();
  }, []);

  function formatToINR(amount) {
    const currecyData = parseFloat(Math.round(amount)).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return currecyData;
  }

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setAllUserName(userList);
        console.log(response.data.data);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleSendBulkPayslip = async () => {
    const monthIndex = new Date(payslipGenerateDate).getMonth();
    const fullyear = new Date(payslipGenerateDate).getFullYear();
    try {
      setLoader(true);

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}payslip/processBulkPayslips`,
        {
          monthIndex: monthIndex,
          year: fullyear,
          XlData: empPayslipData,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const HeaderElements = () => (
    <Box display="flex" alignItems="baseline" gridGap={4}>
      {empPayslipData.length > 0 && (
        <>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSendBulkPayslip}
          >
            Send Payslip
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            className="example-custom-input"
            endIcon={<IoChevronDownSharp />}
            onClick={handlePayslipCalendarOpen}
          >
            {moment(payslipGenerateDate).format("MMM-yyyy")}
          </Button>
          {calendarOpen && (
            <Box
              position="relative"
              zIndex={111}
              className="payslip-month-picker-container"
            >
              <DatePicker
                selected={payslipGenerateDate}
                onChange={handlePayslipMonthChange}
                renderMonthContent={renderMonthContent}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                wrapperClassName="payslip-month-calender"
                popperClassName="payslip-month-calender-popper"
                inline
              />
            </Box>
          )}
        </>
      )}
      <Typography>Total : {empPayslipData.length}</Typography>
    </Box>
  );

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };

  const handleEditItem = (data) => {
    setPayslipUploadModal(true);
    setEditPayslipFields(data);
    console.log("Key:", Object.keys(data), Object.values(data));
    Object.entries(data).forEach(([key, value]) => {
      setValue(key, typeof value === "number" ? Math.round(value) : value);
    });
  };

  const handleCloseEditModal =()=>{
    setPayslipUploadModal(false);
    reset();
  }

  const handleEdit = (values) => {
    const updatedData = empPayslipData.filter((item) => item.id !== values.id);
    setEmpPayslipData([...updatedData, values]);
    handleCloseEditModal();
    handleNotificationCall('Edited Successfull')
  };


  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box>
            <Paper
              variant="outlined"
              style={{
                padding: "20px",
                width: "100%",
                border: "2px dashed #1976d2",
                marginRight: "10px",
              }}
            >
              <Box textAlign="center">
                <img
                  src={excel_icon}
                  style={{ width: "50px", height: "50px" }}
                  width="100%"
                  alt="excel-icon"
                />
                <Typography
                  variant="body2"
                  style={{
                    fontStyle: "italic",
                    color: "#758694",
                    margin: "5px 0px",
                  }}
                >
                  (.XLSX Formats Only)
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  style={{ marginTop: "10px" }}
                >
                  Upload File
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={uploadAndConvertXlsx}
                  />
                </Button>
              </Box>
            </Paper>
          </Box>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          <Box className={classes.generatePayslipTable}>
            <MUIDataTable
              title=""
              options={{
                textLabels: {
                  body: {
                    noMatch: "Oops! Matching record could not be found",
                  },
                },
                pagination: false,
                sort: false,
                selectableRows: "none",
                search: false,
                filter: false,
                download: false,
                print: false,
                fixedSelectColumn: true,
                customToolbar: () => (
                  <>
                    <HeaderElements />
                  </>
                ),
                responsive: mobileQuery === true ? "vertical" : "standard",
              }}
              columns={[
                {
                  name: "S.No",
                  options: {
                    setCellProps: (value, tableMeta) => {
                      return {
                        style: {
                          position: "sticky",
                          left: 0, // Adjust based on column width
                          background: "#fff",
                          zIndex: 1001,
                        },
                      };
                    },
                    setCellHeaderProps: () => ({
                      style: {
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 1002,
                      },
                    }),
                  },
                },
                {
                  name: "Name",
                  options: {
                    setCellProps: (value, tableMeta) => {
                      return {
                        style: {
                          position: "sticky",
                          left: 50, // Adjust based on column width
                          background: "#fff",
                          zIndex: 1001,
                          borderRight: "1px solid #e0e0e0",
                          boxShadow:
                            "inset rgb(195 193 193 / 20%) -2px 0px 0px 0px",
                        },
                      };
                    },
                    setCellHeaderProps: () => ({
                      style: {
                        position: "sticky",
                        left: 50,
                        background: "#fff",
                        zIndex: 1002,
                      },
                    }),
                  },
                },
                {
                  name: "Edit",
                },
                {
                  name: "Email",
                },
                {
                  name: "Join Date",
                },
                {
                  name: "Mode of Payment",
                },
                {
                  name: "Days in Month",
                },
                {
                  name: "Effective Workdays",
                },
                {
                  name: "LOP Count",
                },
                {
                  name: "Basic Allowance Arrears",
                },
                {
                  name: "HRA Allowance Arrears",
                },
                {
                  name: "Telephone Allowance Arrears",
                },
                {
                  name: "Conveyance Arrears",
                },
                {
                  name: "Medical Allowance Arrears",
                },
                {
                  name: "Other Allowance Arrears",
                },
                {
                  name: "Bonus",
                },
                {
                  name: "Incentives",
                },
                {
                  name: "Other Earnings",
                },
                {
                  name: "Arrears",
                },
                {
                  name: "Consultant Arrears",
                },
                {
                  name: "Monthly Performance Arrears",
                },
                {
                  name: "Statutory Bonus Arrears",
                },
                {
                  name: "Refund For Last Month Deduction",
                },
                {
                  name: "Role Performance Bonus",
                },
                {
                  name: "Shift Allowance Arrears",
                },
                {
                  name: "Notice Period Deduction",
                },
                {
                  name: "Special Purpose Deduction",
                },
                {
                  name: "IncomeTax",
                },
                {
                  name: "Other Deduction",
                },
                {
                  name: "Standard Deduction",
                },
                {
                  name: "Total Gross",
                },
                {
                  name: "Total Deduction",
                },
                {
                  name: "Net Value",
                },
              ]}
              data={empPayslipData.map((item, index) => {
                return [
                  <>{index + 1}</>,
                  <Box
                    sx={{
                      color: "inherit",
                      position: "relative",
                    }}
                  >
                    {item.name}
                  </Box>,
                  <>
                    <AiTwotoneEdit
                      size={20}
                      color="064be2"
                      onClick={() => handleEditItem(item)}
                    />
                  </>,
                  item.email,
                  moment(item.joinningDate).format("YYYY-MM-DD"),
                  item.modeOfPayment,
                  moment(payslipGenerateDate, "YYYY-M").daysInMonth(),
                  moment(payslipGenerateDate, "YYYY-M").daysInMonth() -
                    item.lopCount,
                  item.lopCount,
                  formatToINR(item.basicAllowanceArrears),
                  formatToINR(item.hraArrears),
                  formatToINR(item.telephoneAllowanceArrear),
                  formatToINR(item.conveyanceArrears),
                  formatToINR(item.medicalAllowanceArrear),
                  formatToINR(item.otherAllowanceArrear),
                  formatToINR(item.bonus),
                  formatToINR(item.incentives),
                  formatToINR(item.otherEarnings),
                  formatToINR(item.arrears),
                  formatToINR(item.consultantArrears),
                  formatToINR(item.monthlyPerformanceArrears),
                  formatToINR(item.statutoryBonusArrears),
                  formatToINR(item.refundForLastMonthDeduction),
                  formatToINR(item.rolePerformanceBonus),
                  formatToINR(item.shiftAllowanceArrears),
                  formatToINR(item.noticePeriodDeduction),
                  formatToINR(item.specialPurposeDeduction),
                  formatToINR(item.incomeTax),
                  formatToINR(item.otherDeduction),
                  formatToINR(item.standardDeduction),
                  formatToINR(item.totalGross),
                  formatToINR(item.totalDeduction),
                  formatToINR(item.netValue),
                ];
              })}
            />
          </Box>
        </Grid>
      </Grid>

      <Dialog
        open={payslipUploadModal}
        fullWidth
        maxWidth="sm"
        onClose={handleCloseEditModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{"Upload"}</DialogTitle>
        <form onSubmit={handleSubmit(handleEdit)}>
          <DialogContent>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h6">
                    Name : {editPayslipFields.name}{" "}
                  </Typography>
                  <Typography variant="h6">
                    Email: {editPayslipFields.email}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="modeOfPayment">
                    Mode of Payment
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="modeOfPayment"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          error={errors.modeOfPayment ? true : false}
                          classes={{
                            root: classes.customSelectField,
                            icon: classes.customSelectIcon,
                          }}
                          disableUnderline
                        >
                          <MenuItem value="">Select option</MenuItem>
                          <MenuItem value="BANK TRANSFER">Bank Transfer</MenuItem>
                          <MenuItem value="CHEQUE">Cheque</MenuItem>
                          <MenuItem value="NEFT">NEFT</MenuItem>
                          <MenuItem value="CASH">Cash</MenuItem>
                          <MenuItem value="OTHER">
                            Other
                          </MenuItem>
                        </Select>
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {errors.modeOfPayment?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="lopCount">
                    LOP Days Count
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      inputMode="numeric"
                      classes={{ root: classes.customTextField }}
                      size="small"
                      type="number"
                      placeholder="Enter employee LOP Count"
                      {...register("lopCount")}
                      error={errors.lopCount ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.lopCount?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                {allFields.map((field) => (
                  <Grid item xs={12} sm={6} md={6} lg={6} key={field.name}>
                    <InputLabel shrink htmlFor={field.name}>
                      {field.label}
                    </InputLabel>

                    <FormControl fullWidth>
                      <TextField
                        size="small"
                        type="number"
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        inputProps={{ min: 0 }}
                        inputMode="numeric"
                        placeholder={field.placeholder}
                        {...register(field.name)}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    </FormControl>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleCloseEditModal}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="small"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default UploadQuickPayslip;
